const VendorManagementReducer = (state = {}, action) => {
  switch (action.type) {
    case "getSearchVendorZoneListSuccess":
      return Object.assign({}, state, {
        VendorSearchZoneList: action.data,
      });
      break;
    case "getSearchVendorPortListSuccess":
      return Object.assign({}, state, {
        VendorSearchPortList: action.data,
      });
      break;
    case "NewVendorDetailsAdd":
      return Object.assign({}, state, {
        VendorNameEdit: action.data,
      });
      break;
    case "NewEquipmentDetailsAdd":
      return Object.assign({}, state, {
        EquipmentNameEdit: action.data,
      });
      break;
    case "vendorSearch":
      return Object.assign({}, state, {
        vendorSearch: action.data,
      });
      break;
    case "NewZoneDetailsAdd":
      return Object.assign({}, state, {
        ZoneNameEdit: action.data,
      });
      break;
    case "getSearchVendorCountryListSuccess":
      return Object.assign({}, state, {
        VendorSearchCountryList: action.data,
      });
      break;
    case "getSearchVendorVendorsListSuccess":
      return Object.assign({}, state, {
        VendorSearchVendorsList: action.data,
      });
      break;
    case "getSearchVendorEquipmentListSuccess":
      return Object.assign({}, state, {
        VendorSearchEquipmentList: action.data,
      });
      break;

    case "getZoneListSuccess":
      return Object.assign({}, state, {
        zoneList: action.data,
      });
      break;
    case "getUnitListSuccess":
      return Object.assign({}, state, {
        UnitList: action.data,
      });
      break;
    case "getVendorListSuccess":
      return Object.assign({}, state, {
        VendorList: action.data,
      });
      break;
    case "getapplicableVendorListSuccess":
      return Object.assign({}, state, {
        VendorApplicableList: action.data,
      });
      break;

    case "getVendorCountryListSuccess":
      return Object.assign({}, state, {
        VendorCountryList: action.data,
      });
      break;

    case "getVendorDetailSuccess":
      return Object.assign({}, state, {
        VendorDetail: action.data,
      });
      break;
    case "getVendorEquipmentListSuccess":
      return Object.assign({}, state, {
        VendorEquipmentDetailList: action.data,
      });
      break;
    case "getVendorEquipmentDetailSuccess":
      return Object.assign({}, state, {
        VendorEquipmentDetails: action.data,
      });
      break;

    case "postVendorDetailSuccess":
      return Object.assign({}, state, {
        PostVendorDetail: action.data,
      });
      break;
    case "putVendorDetailSuccess":
      return Object.assign({}, state, {
        PutVendorDetail: action.data,
      });
      break;
    default: {
      return state;
    }
  }
};
export default VendorManagementReducer;
